import { axios } from '@/plugins/axios-pol'

export default {
  namespaced: true,

  state: {
    remesas: [],
    remesa: null,
    personalRemesas: [],
  },

  getters: {
    getRemesas: (state) => state.remesas,
    getRemesa: (state) => state.remesa,
    getPersonalRemesas: (state) => state.personalRemesas,
  },

  mutations: {
    SET_REMESAS(state, remesas) {
      state.remesas = remesas
    },
    SET_REMESA(state, remesa) {
      state.remesa = remesa
    },
    SET_PERSONAL_REMESAS(state, personalRemesas) {
      state.personalRemesas = personalRemesas
    },
  },

  actions: {
    async fetchRemesas({ commit }) {
      try {
        const response = await axios.get('/armeria/api/Armeria/remesa')
        commit('SET_REMESAS', response.data.data)
      } catch (error) {
        console.error(error)
      }
    },

    async fetchRemesaById({ commit }, idRemesa) {
      try {
        const response = await axios.get(`/armeria/api/Armeria/remesa/${idRemesa}`)
        commit('SET_REMESA', response.data.data)
      } catch (error) {
        console.error(error)
      }
    },

    async createRemesa({ dispatch }, payload) {
      try {
        await axios.post('/armeria/api/Armeria/remesa', payload)
        dispatch('fetchRemesas')
      } catch (error) {
        console.error(error)
      }
    },

    async updateRemesa({ dispatch }, { idRemesa, payload }) {
      try {
        await axios.put(`/armeria/api/Armeria/remesa/${idRemesa}`, payload)
        dispatch('fetchRemesas')
      } catch (error) {
        console.error(error)
      }
    },

    async fetchPersonalRemesas({ commit }) {
      try {
        const response = await axios.get('/armeria/api/Armeria/personalRemesa')
        commit('SET_PERSONAL_REMESAS', response.data.data)
      } catch (error) {
        console.error(error)
      }
    },

    async fetchPersonalRemesaById({ commit }, idPersonalRemesa) {
      try {
        const response = await axios.get(`/armeria/api/Armeria/personalRemesa/${idPersonalRemesa}`)
        commit('SET_PERSONAL_REMESAS', [response.data.data])
      } catch (error) {
        console.error(error)
      }
    },

    async assignRemesaToPersonal({ dispatch }, { idPersonal, idRemesa }) {
      try {
        await axios.post(`/armeria/api/Armeria/personal/${idPersonal}/personalRemesa`, {
          fk_idPersonal: idPersonal,
          fk_idRemesa: idRemesa,
        })
        dispatch('fetchPersonalRemesas')
      } catch (error) {
        console.error(error)
      }
    },

    async updatePersonalRemesa({ dispatch }, { idPersonal, idPersonalRemesa, payload }) {
      try {
        await axios.put(`/armeria/api/Armeria/personal/${idPersonal}/personalRemesa/${idPersonalRemesa}`, payload)
        dispatch('fetchPersonalRemesas')
      } catch (error) {
        console.error(error)
      }
    },
  },
}
